import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Selector from "./Selector";

const TriggerPoints = ({ app, onChange, triggerPoint = "" }) => {
  const { agent_name: agentName } = useParams();
  const [value, setValue] = useState(triggerPoint);

  // If in agent context, use agent name as trigger point
  useEffect(() => {
    if (agentName) {
      onChange(agentName);
    }
  }, [agentName, onChange]);

  // If agent name exists, don't render the selector
  if (agentName) {
    return null;
  }

  const triggerPoints = [
    { title: "Default", value: "" },
    ...app.trigger_points.map((t) => ({ title: t, value: t })),
  ];

  const handleChange = (val) => {
    setValue(val);
    if (onChange) {
      onChange(val === "Default" ? "" : val);
    }
  };

  return (
    <Selector
      items={triggerPoints}
      customStyles={{
        width: "150px",
        textAlign: "center",
        "& .MuiOutlinedInput-root": {
          padding: "0px",
          height: "20px",
        },
      }}
      defaultValue={value}
      placeholder="Site"
      setValue={(value) => handleChange(value)}
    />
  );
};

export default TriggerPoints;
